module.exports = __webpack_public_path__ + "img/works_beijing_xikemu_5.911e288b.jpg";